/*
 * ============================================================
 * JJ – Box nach Wahl (snippets/jj-box-auswahl.liquid)
 * ============================================================
 * Die Kundin wählt genau N Artikel. «In den Warenkorb» legt die
 * gewählten Artikel EINZELN in den Warenkorb, alle mit derselben
 * versteckten Eigenschaft
 *
 *   _jj_box_id = "<Box-SKU>|<Zufallskennung>"
 *
 * Die Shopify Function jj-bundles fasst diese Zeilen im Warenkorb zur
 * Box zusammen und setzt den Box-Preis. Fehlt danach ein Artikel
 * (z. B. im Warenkorb entfernt), gelten wieder die Einzelpreise.
 *
 * Teile auf der Seite (alle mit data-jj-box-produkt="<Produkt-ID>"):
 *   galerie  Box-Bild links oben
 *   status   Plätze, Fortschritt, Knopf (rechte Spalte)
 *   raster   alle Artikel zum Wählen
 *   sticky   Leiste unten auf dem Handy
 * Die Auswahl bleibt beim Neuladen der Seite erhalten (sessionStorage).
 *
 * Start aus dem Hinweis «Auch als Box nach Wahl» auf einer Artikelseite
 * (snippets/jj-in-box.liquid): ?box_start=<Varianten-ID> legt diesen
 * Artikel einmal in die Auswahl (falls noch nicht drin und Platz frei),
 * zeigt «… ist schon drin» und entfernt den Parameter aus der Adresse.
 * Wird die Box danach in den Warenkorb gelegt, vermerkt jj-ergaenzungen.js
 * im Warenkorb-Attribut _jj_quellen "box_hinweis:<Box-SKU>".
 * ============================================================
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------- */
  /* Hilfsfunktionen                                             */
  /* ---------------------------------------------------------- */

  function geld(rappen, format) {
    var f = format || (window.theme && window.theme.moneyFormat) || '{{amount}}';
    var betrag = (Math.round(rappen) / 100);
    function tausender(zahl, stellen, trenner, dezimal) {
      var teile = zahl.toFixed(stellen).split('.');
      teile[0] = teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, trenner);
      return teile.join(dezimal);
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, art) {
      switch (art) {
        case 'amount_no_decimals': return tausender(betrag, 0, ',', '.');
        case 'amount_with_comma_separator': return tausender(betrag, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return tausender(betrag, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return tausender(betrag, 2, "'", '.');
        default: return tausender(betrag, 2, ',', '.');
      }
    });
  }

  // Platzhalter in den Sprachtexten: __COUNT__, __TOTAL__, __UNIT__, __AMOUNT__, __TITLE__
  function text(vorlage, werte) {
    return String(vorlage || '').replace(/__([A-Z]+)__/g, function (m, k) {
      var key = k.toLowerCase();
      return Object.prototype.hasOwnProperty.call(werte, key) ? werte[key] : m;
    });
  }

  function el(tag, klasse, inhalt) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (inhalt !== undefined && inhalt !== null) e.textContent = inhalt;
    return e;
  }

  function zufall() {
    var zeichen = 'abcdefghijkmnpqrstuvwxyz23456789';
    var s = '';
    var c = window.crypto && window.crypto.getRandomValues ? window.crypto.getRandomValues(new Uint8Array(10)) : null;
    for (var i = 0; i < 10; i++) {
      var r = c ? c[i] : Math.floor(Math.random() * 256);
      s += zeichen.charAt(r % zeichen.length);
    }
    return s;
  }

  /*
   * Anzeigename: Teil vor « – » (sonst ohne « - Marke»), gemeinsamer
   * Wortanfang aller Artikel (z. B. «Steingutbecher») weg, Anführungs-
   * zeichen weg, erster Buchstabe gross.
   *   'Steingutbecher "HELLO NEW DAY" – handgemacht - Eulenschnitt' → HELLO NEW DAY
   *   'Steingutbecher grosses Herz "Mama" – …'                        → Grosses Herz Mama
   */
  function grundname(titel) {
    var t = String(titel || '');
    var i = t.indexOf(' – ');
    if (i > 0) return t.slice(0, i).trim();
    var j = t.lastIndexOf(' - ');
    return (j > 0 ? t.slice(0, j) : t).trim();
  }

  function anzeigenamen(titelListe) {
    var grund = titelListe.map(grundname);
    var woerter = grund.map(function (g) { return g.split(/\s+/); });
    var k = 0;
    if (grund.length >= 2) {
      while (true) {
        var w = woerter[0][k];
        if (w === undefined) break;
        var alle = woerter.every(function (ws) { return ws.length > k + 1 && ws[k] === w; });
        if (!alle) break;
        k++;
      }
    }
    return woerter.map(function (ws, idx) {
      var n = ws.slice(k).join(' ').replace(/["“”„«»]/g, '').replace(/\s+/g, ' ').trim();
      if (!n) n = grund[idx];
      return n.charAt(0).toUpperCase() + n.slice(1);
    });
  }

  /* ---------------------------------------------------------- */
  /* Box                                                         */
  /* ---------------------------------------------------------- */

  function Box(daten) {
    this.d = daten;
    this.t = daten.texte || {};
    this.n = Math.max(1, parseInt(daten.n, 10) || 6);
    this.produkt = String(daten.produkt);
    this.gruppe = '';
    this.laedt = false;

    var namen = anzeigenamen(daten.artikel.map(function (a) { return a.t; }));
    this.artikel = daten.artikel.map(function (a, i) {
      var lager = a.l === null || a.l === undefined ? null : Math.max(0, parseInt(a.l, 10) || 0);
      return {
        id: String(a.id), titel: a.t, name: namen[i], url: a.u, bild: a.b,
        preis: a.p, gruppe: a.g || '',
        lieferbar: !!a.a && (lager === null || lager > 0),
        lager: lager
      };
    });
    this.nachId = {};
    for (var i = 0; i < this.artikel.length; i++) this.nachId[this.artikel[i].id] = this.artikel[i];

    this.speicherSchluessel = 'jj-box-' + this.produkt;
    this.quelleSchluessel = 'jj-box-quelle-' + this.produkt;
    this.startHinweis = '';
    this.auswahl = this._laden();
    this._startArtikel();

    this.teile = {};
    var self = this;
    ['galerie', 'status', 'raster', 'sticky'].forEach(function (teil) {
      self.teile[teil] = document.querySelector('[data-jj-box-teil="' + teil + '"][data-jj-box-produkt="' + self.produkt + '"]');
    });

    this._rasterAufbauen();
    this._ereignisse();
    this._stickyBeobachten();
    this.zeichnen();
  }

  Box.prototype.menge = function (id) {
    var z = 0;
    for (var i = 0; i < this.auswahl.length; i++) if (this.auswahl[i] === id) z++;
    return z;
  };

  Box.prototype.maxFuer = function (a) {
    return a.lager === null ? this.n : Math.min(this.n, a.lager);
  };

  Box.prototype.summe = function () {
    var s = 0, self = this;
    this.auswahl.forEach(function (id) { s += self.nachId[id] ? self.nachId[id].preis : 0; });
    return s;
  };

  Box.prototype._laden = function () {
    try {
      var roh = window.sessionStorage.getItem(this.speicherSchluessel);
      var liste = roh ? JSON.parse(roh) : [];
      var self = this, gezaehlt = {}, sauber = [];
      (Array.isArray(liste) ? liste : []).forEach(function (id) {
        var a = self.nachId[String(id)];
        if (!a || !a.lieferbar) return;
        gezaehlt[a.id] = (gezaehlt[a.id] || 0) + 1;
        if (gezaehlt[a.id] > self.maxFuer(a) || sauber.length >= self.n) return;
        sauber.push(a.id);
      });
      return sauber;
    } catch (e) {
      return [];
    }
  };

  /* Vorauswahl aus dem Hinweis auf der Artikelseite (?box_start=<ID>) */
  Box.prototype._startArtikel = function () {
    var id = null;
    try { id = new URLSearchParams(window.location.search).get('box_start'); } catch (e) { return; }
    if (!id) return;

    // Parameter entfernen: Neuladen oder Teilen der Adresse fügt nicht nochmals hinzu
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('box_start');
      window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
    } catch (e) { /* egal */ }

    try { window.sessionStorage.setItem(this.quelleSchluessel, 'box_hinweis'); } catch (e) { /* egal */ }

    var a = this.nachId[String(id).replace(/\D/g, '')];
    if (!a || !a.lieferbar) return;
    if (this.menge(a.id) === 0) {
      if (this.auswahl.length >= this.n) return;
      this.auswahl.unshift(a.id);
      this._speichern();
    }
    this.startHinweis = a.name;
  };

  Box.prototype._quelle = function () {
    try { return window.sessionStorage.getItem(this.quelleSchluessel) || ''; } catch (e) { return ''; }
  };

  Box.prototype._speichern = function () {
    try { window.sessionStorage.setItem(this.speicherSchluessel, JSON.stringify(this.auswahl)); } catch (e) { /* egal */ }
  };

  Box.prototype.plus = function (id) {
    var a = this.nachId[id];
    if (!a || !a.lieferbar || this.auswahl.length >= this.n || this.menge(id) >= this.maxFuer(a)) return;
    this.auswahl.push(id);
    this._aenderung();
  };

  Box.prototype.minus = function (id) {
    var i = this.auswahl.lastIndexOf(id);
    if (i < 0) return;
    this.auswahl.splice(i, 1);
    this._aenderung();
  };

  Box.prototype.entfernenAn = function (index) {
    if (index < 0 || index >= this.auswahl.length) return;
    this.auswahl.splice(index, 1);
    this._aenderung();
  };

  Box.prototype._aenderung = function () {
    this.startHinweis = '';
    this._speichern();
    this._fehler('');
    this.zeichnen();
  };

  /* ---------------- Raster (einmal aufbauen, dann nur aktualisieren) */

  Box.prototype._rasterAufbauen = function () {
    var r = this.teile.raster;
    if (!r) return;
    var t = this.t, self = this;

    // Filter nur, wenn mindestens zwei Gruppen Artikel haben
    var chips = r.querySelector('[data-jj-box-chips]');
    var gruppen = (this.d.gruppen || []).filter(function (g) {
      return self.artikel.some(function (a) { return a.gruppe === g.k; });
    });
    if (chips && gruppen.length >= 2) {
      var alle = [{ k: '', label: t.all, n: this.artikel.length }].concat(gruppen.map(function (g) {
        return { k: g.k, label: g.label, n: self.artikel.filter(function (a) { return a.gruppe === g.k; }).length };
      }));
      alle.forEach(function (g) {
        var b = el('button', 'jj-box-chip', g.label + ' (' + g.n + ')');
        b.type = 'button';
        b.setAttribute('data-jj-box-chip', g.k);
        b.setAttribute('aria-pressed', g.k === '' ? 'true' : 'false');
        chips.appendChild(b);
      });
      chips.hidden = false;
    }

    var karten = r.querySelector('[data-jj-box-karten]');
    if (!karten) return;
    karten.innerHTML = '';
    this.karten = {};
    this.artikel.forEach(function (a) {
      var k = el('div', 'jj-box-karte');
      k.setAttribute('data-gruppe', a.gruppe);

      var bild = el('div', 'jj-box-karte__bild');
      if (a.bild) {
        var img = el('img');
        img.src = a.bild; img.alt = a.titel; img.loading = 'lazy'; img.width = 400; img.height = 400;
        bild.appendChild(img);
      }
      var menge = el('span', 'jj-box-karte__menge');
      bild.appendChild(menge);
      var mehr = el('a', 'jj-box-karte__mehr', 'i');
      mehr.href = a.url; mehr.target = '_blank'; mehr.rel = 'noopener';
      mehr.setAttribute('aria-label', a.titel);
      mehr.title = a.titel;
      bild.appendChild(mehr);
      k.appendChild(bild);

      var inhalt = el('div', 'jj-box-karte__inhalt');
      inhalt.appendChild(el('div', 'jj-box-karte__name', a.name));
      var lager = el('div', 'jj-box-karte__lager');
      inhalt.appendChild(lager);
      var steuer = el('div', 'jj-box-karte__steuer');
      inhalt.appendChild(steuer);
      k.appendChild(inhalt);

      karten.appendChild(k);
      self.karten[a.id] = { karte: k, menge: menge, lager: lager, steuer: steuer, zustand: null };
    });
  };

  Box.prototype._karteZeichnen = function (a) {
    var k = this.karten && this.karten[a.id];
    if (!k) return;
    var t = this.t;
    var q = this.menge(a.id);
    var voll = this.auswahl.length >= this.n;
    var maxErreicht = q >= this.maxFuer(a);

    k.karte.classList.toggle('jj-box-karte--gewaehlt', q > 0);
    k.karte.classList.toggle('jj-box-karte--aus', !a.lieferbar);
    k.menge.textContent = q + '×';

    if (!a.lieferbar) {
      k.lager.className = 'jj-box-karte__lager jj-box-karte__lager--aus';
      k.lager.textContent = t.sold_out;
    } else if (a.lager !== null && a.lager <= 5) {
      k.lager.className = 'jj-box-karte__lager jj-box-karte__lager--wenig';
      k.lager.textContent = text(t.low_stock, { count: a.lager });
    } else {
      k.lager.className = 'jj-box-karte__lager jj-box-karte__lager--ok';
      k.lager.textContent = t.in_stock;
    }

    // Steuerung nur neu bauen, wenn sich der Zustand geändert hat
    var zustand = [q, voll, maxErreicht, a.lieferbar].join('|');
    if (k.zustand === zustand) return;
    k.zustand = zustand;
    k.steuer.innerHTML = '';

    if (q === 0) {
      var plus = el('button', 'jj-box-karte__plus', t.add_item);
      plus.type = 'button';
      plus.setAttribute('data-jj-box-plus', a.id);
      plus.setAttribute('aria-label', a.name + ': ' + t.add_item);
      plus.disabled = voll || !a.lieferbar;
      k.steuer.appendChild(plus);
    } else {
      var m = el('button', 'jj-box-karte__m', '−');
      m.type = 'button';
      m.setAttribute('data-jj-box-minus', a.id);
      m.setAttribute('aria-label', text(t.less, { title: a.name }));
      var anz = el('span', 'jj-box-karte__q', String(q));
      var p = el('button', 'jj-box-karte__p', '+');
      p.type = 'button';
      p.setAttribute('data-jj-box-plus', a.id);
      p.setAttribute('aria-label', text(t.more, { title: a.name }));
      p.disabled = voll || maxErreicht;
      k.steuer.appendChild(m);
      k.steuer.appendChild(anz);
      k.steuer.appendChild(p);
    }
  };

  /* ---------------- Gesamtdarstellung */

  Box.prototype.zeichnen = function () {
    var self = this, t = this.t;
    var n = this.n, anzahl = this.auswahl.length, rest = n - anzahl;
    var summe = this.summe();
    var ersparnis = summe - this.d.preis;

    // Raster
    this.artikel.forEach(function (a) { self._karteZeichnen(a); });

    // Galerie
    var g = this.teile.galerie;
    if (g) {
      var feld = g.querySelector('[data-jj-box-feld]');
      if (feld) {
        var plaetze = feld.children;
        for (var i = 0; i < plaetze.length; i++) {
          var a = this.nachId[this.auswahl[i]];
          var platz = plaetze[i];
          var soll = a ? a.id : '';
          if (platz.getAttribute('data-id') === soll) continue;
          platz.setAttribute('data-id', soll);
          platz.innerHTML = '';
          platz.classList.toggle('jj-box-galerie__platz--voll', !!a);
          if (a && a.bild) {
            var im = el('img'); im.src = a.bild; im.alt = a.name; platz.appendChild(im);
          } else if (!a) {
            platz.appendChild(el('span', '', '+'));
          } else {
            platz.appendChild(el('span', '', a.name));
          }
        }
      }
      var ft = g.querySelector('[data-jj-box-feldtext]');
      if (ft) ft.textContent = anzahl ? this.auswahl.map(function (id) { return self.nachId[id].name; }).join(' · ') : t.gallery_empty;
    }

    // Status
    var s = this.teile.status;
    if (s) {
      var zahl = s.querySelector('[data-jj-box-zahl]');
      if (zahl) zahl.textContent = text(t.count, { count: anzahl, total: n });
      var balken = s.querySelector('[data-jj-box-balken]');
      if (balken) balken.style.width = (anzahl / n * 100) + '%';

      var sp = s.querySelector('[data-jj-box-plaetze]');
      if (sp) {
        var kinder = sp.children;
        for (var j = 0; j < kinder.length; j++) {
          var b = this.nachId[this.auswahl[j]];
          var feldS = kinder[j];
          var sollS = b ? b.id + '@' + j : '';
          if (feldS.getAttribute('data-id') === sollS) continue;
          feldS.setAttribute('data-id', sollS);
          feldS.innerHTML = '';
          feldS.classList.toggle('jj-box-status__platz--voll', !!b);
          if (b) {
            if (b.bild) { var bi = el('img'); bi.src = b.bild; bi.alt = b.name; feldS.appendChild(bi); }
            else feldS.appendChild(el('span', '', b.name));
            var x = el('button', '', '×');
            x.type = 'button';
            x.setAttribute('data-jj-box-weg', String(j));
            x.setAttribute('aria-label', text(t.remove, { title: b.name }));
            feldS.appendChild(x);
          } else {
            feldS.textContent = String(j + 1);
          }
        }
      }

      var hinweis = s.querySelector('[data-jj-box-hinweis]');
      if (hinweis) {
        if (anzahl === 0) hinweis.textContent = text(t.hint_start, { count: n, unit: this.d.einheit });
        else if (this.startHinweis && rest > 0 && t.start_hint) hinweis.textContent = text(t.start_hint, { title: this.startHinweis, count: rest, unit: this.d.einheit });
        else if (rest > 0) hinweis.textContent = text(t.hint_sum, { count: anzahl, unit: this.d.einheit, amount: geld(summe, this.d.format) });
        else if (ersparnis > 0) hinweis.textContent = text(t.hint_done, { amount: geld(ersparnis, this.d.format) });
        else hinweis.textContent = t.hint_done_plain;
      }
    }

    // Knöpfe (rechts und Sticky)
    var knopfText = rest > 0
      ? text(t.choose_more, { count: rest, unit: this.d.einheit })
      : text(t.add, { amount: geld(this.d.preis, this.d.format) });
    document.querySelectorAll('[data-jj-box-produkt="' + this.produkt + '"] [data-jj-box-knopf]').forEach(function (k) {
      k.disabled = rest > 0 || self.laedt;
      if (self.laedt) return;
      // Sticky-Leiste auf dem Handy: kurzer Text, der Preis steht daneben
      var kurz = rest === 0 && k.closest('[data-jj-box-teil="sticky"]') && t.add_short;
      k.textContent = kurz ? t.add_short : knopfText;
    });

    // Sticky
    var st = this.teile.sticky;
    if (st) {
      var punkte = st.querySelector('[data-jj-box-punkte]');
      if (punkte && punkte.children.length !== n) {
        punkte.innerHTML = '';
        for (var p = 0; p < n; p++) punkte.appendChild(el('i'));
      }
      if (punkte) for (var q = 0; q < punkte.children.length; q++) punkte.children[q].className = q < anzahl ? 'voll' : '';
      var sz = st.querySelector('[data-jj-box-sticky-zahl]');
      if (sz) sz.textContent = text(t.sticky_count, { count: anzahl, total: n });
    }
  };

  Box.prototype._fehler = function (meldung) {
    var s = this.teile.status;
    var f = s && s.querySelector('[data-jj-box-fehler]');
    if (!f) return;
    f.textContent = meldung || '';
    f.hidden = !meldung;
  };

  /* ---------------- Ereignisse */

  Box.prototype._ereignisse = function () {
    var self = this;
    var wurzeln = document.querySelectorAll('[data-jj-box-produkt="' + this.produkt + '"]');

    Array.prototype.forEach.call(wurzeln, function (w) {
      w.addEventListener('click', function (e) {
        var z = e.target.closest ? e.target.closest('button') : null;
        if (!z) return;

        if (z.hasAttribute('data-jj-box-plus')) { e.preventDefault(); self.plus(z.getAttribute('data-jj-box-plus')); return; }
        if (z.hasAttribute('data-jj-box-minus')) { e.preventDefault(); self.minus(z.getAttribute('data-jj-box-minus')); return; }
        if (z.hasAttribute('data-jj-box-weg')) { e.preventDefault(); self.entfernenAn(parseInt(z.getAttribute('data-jj-box-weg'), 10)); return; }
        if (z.hasAttribute('data-jj-box-chip')) { e.preventDefault(); self.filtern(z.getAttribute('data-jj-box-chip')); return; }
        if (z.hasAttribute('data-jj-box-knopf')) { e.preventDefault(); e.stopPropagation(); self.inDenWarenkorb(); }
      });
    });

    // Sprung-Link sanft scrollen
    var springen = this.teile.status && this.teile.status.querySelector('[data-jj-box-springen]');
    if (springen && this.teile.raster) {
      springen.addEventListener('click', function (e) {
        e.preventDefault();
        self.teile.raster.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  };

  Box.prototype.filtern = function (gruppe) {
    this.gruppe = gruppe || '';
    var self = this;
    var r = this.teile.raster;
    if (!r) return;
    r.querySelectorAll('[data-jj-box-chip]').forEach(function (c) {
      c.setAttribute('aria-pressed', c.getAttribute('data-jj-box-chip') === self.gruppe ? 'true' : 'false');
    });
    this.artikel.forEach(function (a) {
      var k = self.karten[a.id];
      if (k) k.karte.hidden = !!self.gruppe && a.gruppe !== self.gruppe;
    });
  };

  Box.prototype._stickyBeobachten = function () {
    var st = this.teile.sticky;
    var knopf = this.teile.status && this.teile.status.querySelector('[data-jj-box-knopf]');
    if (!st || !knopf || !('IntersectionObserver' in window)) return;
    var beob = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        var zeigen = !e.isIntersecting;
        st.classList.toggle('jj-box-sticky--sichtbar', zeigen);
        st.setAttribute('aria-hidden', zeigen ? 'false' : 'true');
      });
    }, { threshold: 0.1 });
    beob.observe(knopf);
  };

  /* ---------------- Warenkorb */

  Box.prototype.inDenWarenkorb = function () {
    if (this.laedt || this.auswahl.length !== this.n) return;
    var self = this, t = this.t;
    var r = window.routes || {};
    var kennung = String(this.d.sku || 'box') + '|' + zufall();

    // Gleiche Artikel zusammenfassen, Reihenfolge der Auswahl behalten
    var mengen = {}, reihenfolge = [];
    this.auswahl.forEach(function (id) {
      if (!mengen[id]) { mengen[id] = 0; reihenfolge.push(id); }
      mengen[id]++;
    });
    var items = reihenfolge.map(function (id) {
      return { id: Number(id), quantity: mengen[id], properties: { _jj_box_id: kennung } };
    });

    this.laedt = true;
    this._fehler('');
    document.querySelectorAll('[data-jj-box-produkt="' + this.produkt + '"] [data-jj-box-knopf]').forEach(function (k) {
      k.disabled = true;
      k.textContent = t.adding;
    });
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch((r.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (antwort) {
        return antwort.json().then(function (inhalt) {
          if (!antwort.ok) {
            var f = new Error(inhalt.description || inhalt.message || 'Fehler');
            f.beschreibung = inhalt.description || '';
            throw f;
          }
          return inhalt;
        });
      })
      .then(function () {
        // Herkunft vermerken (Hinweis auf der Artikelseite), danach vergessen
        var quelle = self._quelle();
        if (quelle) {
          try { window.sessionStorage.removeItem(self.quelleSchluessel); } catch (e) { /* egal */ }
          var jj = window.JJErgaenzungen;
          if (jj && typeof jj.quelleVermerken === 'function') {
            return jj.quelleVermerken(quelle, self.d.sku || '').then(function () { return null; }, function () { return null; });
          }
        }
        return null;
      })
      .then(function () {
        self.laedt = false;
        self.startHinweis = '';
        self.auswahl = [];
        self._speichern();
        self.zeichnen();
        var hinweis = self.teile.status && self.teile.status.querySelector('[data-jj-box-hinweis]');
        if (hinweis) hinweis.textContent = t.added;

        var th = window.theme || {};
        if (th.cartType === 'page') {
          window.location.href = r.cartUrl || '/cart';
          return;
        }
        // Gleiches Ereignis wie der Kaufknopf des Themes: Mini-Warenkorb
        // wird neu gerendert und geöffnet.
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { button: null, variant: null, quantity: self.n, productAdded: true }
        }));
      })
      .catch(function (fehler) {
        self.laedt = false;
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        self.zeichnen();
        self._fehler(fehler.beschreibung || t.error);
      });
  };

  /* ---------------------------------------------------------- */
  /* Start                                                       */
  /* ---------------------------------------------------------- */

  function starten() {
    document.querySelectorAll('script[data-jj-box-daten]').forEach(function (s) {
      if (s.getAttribute('data-jj-box-gestartet')) return;
      s.setAttribute('data-jj-box-gestartet', '1');
      try {
        var daten = JSON.parse(s.textContent);
        if (!daten || !Array.isArray(daten.artikel)) return;
        new Box(daten);
      } catch (e) {
        if (window.console) console.warn('JJ Box: Daten nicht lesbar', e);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starten);
  else starten();

  window.JJBox = { anzeigenamen: anzeigenamen, geld: geld, starten: starten };
})();
